module.exports = __webpack_public_path__ + "static/media/office_11@2x.521135ae.jpg";